/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Created_ToInputs */

const en_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const fr_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const de_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const it_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const ru_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const es_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const zh_cn2_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const ja_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const hi_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

const pt_pt2_explorer_search_created_to = /** @type {(inputs: Explorer_Search_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

/**
* | output |
* | --- |
* | "Created to" |
*
* @param {Explorer_Search_Created_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_created_to = /** @type {((inputs?: Explorer_Search_Created_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Created_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_created_to(inputs)
	if (locale === "de") return de_explorer_search_created_to(inputs)
	if (locale === "it") return it_explorer_search_created_to(inputs)
	if (locale === "ru") return ru_explorer_search_created_to(inputs)
	if (locale === "es") return es_explorer_search_created_to(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_created_to(inputs)
	if (locale === "ja") return ja_explorer_search_created_to(inputs)
	if (locale === "hi") return hi_explorer_search_created_to(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_created_to(inputs)
	return en_explorer_search_created_to(inputs)
});